import React from 'react'
import './AddCompany.css'
import { Button, Card, Col, Row } from 'antd';
import { useNavigate } from "react-router-dom";
import { CheckCircleFilled, ClockCircleFilled } from '@ant-design/icons';
import { BsMap } from "react-icons/bs";

function AddCompany() {
    const navigate = useNavigate();
    const handlecompany = () => {
        navigate('/addcompanylocation');
    }
    return (
        <div className='flex flex-row'>
            <div className="left-back w-1/2 h-screen">
                <p className='add-lorem-titla'>Lorem Ipsum Company</p>
                <p className='add-name'> Bhaskar Sharma</p>
                <div className='car-con'>
                    <Card
                        className='car-back'
                        style={{
                            width: 200,
                            height: 80,
                            fontSize: '12px',
                            fontWeight: 'bold',
                            color: '#60626F',
                        }}
                    >
                        <p>Aadhar No.:3458709854864</p>
                        <p>Phone No.:3458709854864</p>
                        <p>Email:3458709854864</p>
                    </Card>
                </div>
                <div className='mt-5 sub-topic'>
                    <p className='comapny-topic'><ClockCircleFilled className='comany-icon' />Add Other companies</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Company Address</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Office maps location</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Department & Designation</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Contractor</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Leave type</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Leave Setting</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Attendance Setting</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Derectory Setting</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Add Staff</p>
                    <p className='comapny-topic mt-1'><CheckCircleFilled className='comany-icon1' />Department Heads</p>
                </div>
            </div>
            <div className="w-1/2  flex flex-col">
                <div className=" mt-5 flex justify-between praavi-titel items-center">
                    <span className='company-logo mr-3'>P</span>
                    <span className='company-logo mr-3'>R</span>
                    <span className='company-logo mr-3'>A</span>
                    <span className='company-logo mr-3'>A</span>
                    <span className='company-logo mr-3'>V</span>
                    <span className='company-logo'>I</span>
                </div>
                <div className=" flex justify-between bui-title items-center">
                    <span className='add-bui mr-1'>B</span>
                    <span className='add-bui mr-1'>U</span>
                    <span className='add-bui mr-1'>S</span>
                    <span className='add-bui mr-1'>I</span>
                    <span className='add-bui mr-1'>N</span>
                    <span className='add-bui mr-1'>E</span>
                    <span className='add-bui mr-1'>S</span>
                    <span className='add-bui mr-1'>S</span>
                    <span className='add-bui mr-1'>O</span>
                    <span className='add-bui mr-1'>W</span>
                    <span className='add-bui mr-1'>N</span>
                    <span className='add-bui mr-1'>E</span>
                    <span className='add-bui mr-1'>R</span>
                </div>
                <div>
                    <p className='add-company'>Add Company Locations</p>
                </div>
                <div className='flex mt-3'>
                    <div className='company-back ml-5'>
                        <Row>
                            <Col lg={20}>
                                <p className='compa-name'>Company 1</p>
                                <p className='compa-name'>ABC Enterprice LLC</p>
                                <p className='compa-name'>ACBDT676F</p>

                            </Col>
                            <Col lg={4}>
                                <BsMap className='mt-3 map-icon ml-3' />
                            </Col>
                        </Row>
                    </div>
                    <div className='company-back ml-5'>
                        <Row>
                            <Col lg={20}>
                                <p className='compa-name'>Company 1</p>
                                <p className='compa-name'>ABC Enterprice LLC</p>
                                <p className='compa-name'>ACBDT676F</p>

                            </Col>
                            <Col lg={4}>
                                <BsMap className='mt-3 map-icon ml-3' />
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className='add-new-company'>
                    <p className='add-new-tital'>Company 4</p>
                    <input
                        placeholder="Company Name"
                        className="company-add"
                    />
                    <input
                        placeholder="Company Name"
                        className="company-add"
                    />
                    <input
                        placeholder="PAN"
                        className="company-add"
                    />
                    <input
                        placeholder="CIN"
                        className="company-add"
                    />
                </div>
                <div>
                    <p className='add-plush'>+Add More Company</p>
                </div>
                <div className='flex buttons mt-5'>
                    <Button className='company-add-back'>Back</Button>
                    <Button className='company-add-next' onClick={handlecompany}>Next</Button>

                </div>
            </div>

        </div>
    )
}

export default AddCompany